
export const PERMISSIONS = {

  DASHBOARD_ACCESS: "dasb:v",

  CAF_MANAGE: "caf:m",
  OTT_MANAGE: "ott:m",

  // VAS and OTT Module Permissions (View + Manage)
  VAS_OTT_DIGITAL_SERVICES_VIEW: "vas-ott:dig-svc:v",
  VAS_OTT_DIGITAL_SERVICES_MANAGE: "vas-ott:dig-svc:m",
  VAS_OTT_VAS_PROVIDER_PACKAGES_VIEW: "vas-ott:vas-pkg:v",
  VAS_OTT_VAS_PROVIDER_PACKAGES_MANAGE: "vas-ott:vas-pkg:m",
  VAS_OTT_VAS_AGGREGATES_VIEW: "vas-ott:vas-agg:v",
  VAS_OTT_VAS_AGGREGATES_MANAGE: "vas-ott:vas-agg:m",
  VAS_OTT_BUNDLES_VIEW: "vas-ott:bnd:v",
  VAS_OTT_BUNDLES_MANAGE: "vas-ott:bnd:m",
  VAS_OTT_AUTO_ELIGIBILITY_VIEW: "vas-ott:auto-elg:v",
  VAS_OTT_AUTO_ELIGIBILITY_MANAGE: "vas-ott:auto-elg:m",
  VAS_OTT_CUSTOMERS_VIEW: "vas-ott:cus:v",
  VAS_OTT_CUSTOMERS_MANAGE: "vas-ott:cus:m",
  VAS_OTT_MANUAL_CONSOLE_VIEW: "vas-ott:man-con:v",
  VAS_OTT_MANUAL_CONSOLE_MANAGE: "vas-ott:man-con:m",
  VAS_OTT_COUPONS_VIEW: "vas-ott:cpn:v",
  VAS_OTT_COUPONS_MANAGE: "vas-ott:cpn:m",
  VAS_OTT_SOURCE_CONFIG_VIEW: "vas-ott:src-cfg:v",
  VAS_OTT_SOURCE_CONFIG_MANAGE: "vas-ott:src-cfg:m",
  VAS_OTT_AUDIT_VIEW: "vas-ott:adt:v",

  DOCKET_VIEW: "dct:dkt:v",
  DOCKET_CREATE: "dct:dkt:c",
  DOCKET_EDIT: "dct:dkt:e",
  DOCKET_CREATE_INTERNAL: "dct:dkt:int",
  DOCKET_CREATE_BROADBAND: "dct:dkt:bb",
  DOCKET_COMMENT_ADD: "dct:cmt:a",
  DOCKET_COMMENT_CUSTOMER: "dct:cmt:cus",
  DOCKET_ATTACHMENT_ADD: "dct:att:a",

  DOCKET_DEPARTMENT_VIEW: "dct:dept:v",
  DOCKET_DEPARTMENT_CREATE: "dct:dept:c",
  DOCKET_DEPARTMENT_EDIT: "dct:dept:e",

  DOCKET_DESIGNATION_VIEW: "dct:desg:v",
  DOCKET_DESIGNATION_CREATE: "dct:desg:c",
  DOCKET_DESIGNATION_EDIT: "dct:desg:e",

  DOCKET_OFFICE_VIEW: "dct:ofc:v",
  DOCKET_OFFICE_CREATE: "dct:ofc:c",
  DOCKET_OFFICE_EDIT: "dct:ofc:e",

  DOCKET_TEAM_VIEW: "dct:team:v",
  DOCKET_TEAM_CREATE: "dct:team:c",
  DOCKET_TEAM_EDIT: "dct:team:e",

  DOCKET_EMPLOYEE_VIEW: "dct:emp:v",
  DOCKET_EMPLOYEE_CREATE: "dct:emp:c",
  DOCKET_EMPLOYEE_EDIT: "dct:emp:e",

  OPERATIONS_CUSTOMER_VIEW: "ops:cus:v",
  OPERATIONS_CUSTOMER_RENEW: "ops:cus:rnw",
  OPERATIONS_CUSTOMER_UPGRADE: "ops:cus:upg",
  OPERATIONS_WALLET_RECHARGE_MANAGE: "ops:zn-walt:m",
  OPERATIONS_ZONEPAY_TRANSACTION_VIEW: "ops:zn-txn:v",
  OPERATIONS_ONLINEPAY_TRANSACTION_VIEW: "ops:onp-txn:v",

  ACCOUNTS_ZONE_STATEMENT_VIEW: "aco:zn-stmt:v",
  ACCOUNTS_CUSTOMER_RENEW_RECORD_VIEW: "aco:cus-rnw:v",
  ACCOUNTS_ZONE_BALANCE_VIEW: "aco:zn-bal:v",
  ACCOUNTS_ZONE_COMMISSION_VIEW: "aco:zn-comms:v",
  ACCOUNTS_ZONE_COMMISSION_MANAGE: "aco:zn-comms:m",
  ACCOUNTS_INVOICE_SYNC_COUNT_VIEW: "aco:inv-sync-cnt:v",
  ACCOUNTS_ORPHAN_INVOICE_VIEW: "aco:ophn-inv:v",
  ACCOUNTS_ADJUSTMENT_UPLOAD: "aco:data:upd",
  ACCOUNTS_ADJUSTMENT_DATA_VIEW: "aco:data:v",

  NOTIFICATION_DASHBOARD_VIEW: "msg:dasb:v",
  NOTIFICATION_TEMPLATE_VIEW: "msg:tpl:v",
  NOTIFICATION_CHANNEL_ROUTE_VIEW: "msg:cnr:v",
  NOTIFICATION_EMAIL_CONFIG_VIEW: "msg:mail-cfg:v",
  NOTIFICATION_SMS_CONFIG_VIEW: "msg:sms-cfg:v",
  NOTIFICATION_SEND: "msg:send",

  ADMIN_COMPANY_MANAGE: "sys-cfg:comp:m", // that has to change with cfg:comp:m
  ADMIN_BUILD_INFO:  "sys-cfg:bld:info",
  ADMIN_SERVER_VIEW: "cfg:srv:v",
  ADMIN_SERVER_MANAGE: "cfg:srv:m",
  ADMIN_PACKAGE_VIEW: "cfg:pkg:v",
  ADMIN_PACKAGE_MANAGE: "cfg:pkg:m",
  ADMIN_ZONE_VIEW: "cfg:zn:v",
  ADMIN_ZONE_MANAGE: "cfg:zn:m",
  ADMIN_DISTRIBUTOR_VIEW: "cfg:dtr:v",
  ADMIN_DISTRIBUTOR_MANAGE: "cfg:dtr:m",
  ADMIN_LEGAL_OFFICE_VIEW: "cfg:lgl-ofc:v",
  ADMIN_LEGAL_OFFICE_MANAGE: "cfg:lgl-ofc:m",
  ADMIN_SUPPORT_OFFICE_VIEW: "cfg:sup-ofc:v",
  ADMIN_SUPPORT_OFFICE_MANAGE: "cfg:sup-ofc:m",
  ADMIN_ZONE_COMMISSION_RULE_VIEW: "cfg:comms-rule:v",
  ADMIN_ZONE_COMMISSION_RULE_MANAGE: "cfg:comms-rule:m",
  ADMIN_MODULE_CONFIG_VIEW: "cfg:app-cfg:v",
  ADMIN_MODULE_CONFIG_MANAGE: "cfg:app-cfg:m",
  ADMIN_DATA_RESTRICTION_VIEW: "cfg:data-rst:v",
  ADMIN_DATA_RESTRICTION_MANAGE: "cfg:data-rst:m",
  ADMIN_PACKAGE_WHITELIST_VIEW: "cfg:pkg-wl:v",
  ADMIN_PACKAGE_WHITELIST_MANAGE: "cfg:pkg-wl:m",
  ADMIN_ZONE_USER_VIEW: "cfg:zn-usr:v",
  ADMIN_ZONE_USER_MANAGE: "cfg:zn-usr:m",
  ADMIN_PAYMENT_GATEWAY_VIEW: "cfg:paygw:v",
  ADMIN_PAYMENT_GATEWAY_MANAGE: "cfg:paygw:m",
  ADMIN_NAS_VIEW: "cfg:nas:v",
  ADMIN_NAS_MANAGE: "cfg:nas:m",
  ADMIN_IPMGR_VIEW: "cfg:ipmgr:v",
  ADMIN_IPMGR_MANAGE: "cfg:ipmgr:m",
  ADMIN_COMMON_DELETE: "cfg:common:d",

  ADMIN_IDENTITY_USER_VIEW: "cfg:idn-usr:v",
  ADMIN_IDENTITY_USER_MANAGE: "cfg:idn-usr:m",
  ADMIN_IDENTITY_USER_GROUP_VIEW: "cfg:idn-usr-grp:v",
  ADMIN_IDENTITY_USER_GROUP_MANAGE: "cfg:idn-usr-grp:m",

  SYSTEM_ADMIN_COMPANY_CREATE: "sys-cfg:comp:c",
  SYSTEM_ADMIN_COMPANY_MANAGE: "sys-cfg:comp:m",
  SYSTEM_ADMIN_CACHE_VIEW: "cache:v",

};

/**
 * Get all permissions
 */
export const getAllPermissions = () => Object.values(PERMISSIONS);

/**
 * Get permission count
 */
export const getPermissionCount = () => Object.keys(PERMISSIONS).length;

export default PERMISSIONS;
